import BlogTwentyEightContainer from "./container/BlogTwentyEightContainer";
export default BlogTwentyEightContainer;
